// Modules
import { useCallback } from "react";

// Types
import { Category } from "interfaces/category";

// Hooks
import { useFilterAccordionContent } from "hooks/useFilterAccordionContent";
import useRouting from "hooks/useRouting";

// Redux
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {addSortedSelectedFilter, removeSortedSelectedFilter, urlPathSelector } from "redux/filters/filtersSlice";
import { categoriesSelector } from "redux/categories/categoriesSlice";

// Utils
import {filterQueryStringByAllowedTagParams, getNextUrl} from "utils/queryString";

interface FilterAccordionContentProps {
	currentTag: Category;
	macroCategory: Category;
	selectedTags: Category[];
}

const FilterAccordionContent = ({ currentTag, macroCategory, selectedTags }: FilterAccordionContentProps) => {
	const dispatch = useAppDispatch();
	const urlPath = useAppSelector(urlPathSelector);
	const categories = useAppSelector(categoriesSelector)

	const { isActiveFilter, nextUrl } = useFilterAccordionContent(macroCategory, selectedTags, currentTag, urlPath);
	const pushNewRoute = useRouting();

	const buildHrefUrl = (category: Category) => {
		if (selectedTags) {
			let updatedSelectedCategories: Category[] = [...selectedTags];
			if (selectedTags.find((selectedCategory) => selectedCategory.id === category.id)) {
				updatedSelectedCategories = selectedTags.filter((selectedCategory) => selectedCategory.id !== category.id);
			} else {
				updatedSelectedCategories.push(category);
			}

			const allowedParameters = categories.map(category => category.urlParameter);
			const filteredUrl = filterQueryStringByAllowedTagParams(urlPath, allowedParameters);

			return getNextUrl(macroCategory, updatedSelectedCategories, filteredUrl, categories);
		}
	};

	const filterOnChangeHandler = useCallback(() => {
		if (isActiveFilter(currentTag.id)) {
			dispatch(removeSortedSelectedFilter(currentTag));
		} else {
			dispatch(addSortedSelectedFilter(currentTag));
		}

		pushNewRoute(nextUrl);
	}, [nextUrl]);

	return (
		<li className={`filtersModule__btn ${isActiveFilter(currentTag.id) ? "filtersModule__btn--active" : ""}`} onClick={filterOnChangeHandler}>
			<a href={`/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}/${buildHrefUrl(currentTag)}`} onClick={(event) => event.preventDefault()}>
				{currentTag.name}
			</a>
		</li>
	);
};

export default FilterAccordionContent;
